module.exports = __webpack_public_path__ + "img/drifting-luminescence.a7d0cf59.webp";